export default "__VITE_ASSET__abc3c6ef__"